import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// import { useAuth } from "../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";
import TableLoader from "../../../Skeleton/TableLoader";
import Pagination from "../../../utils/Paginate";
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");
const ListContentCategories = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
//   const { token, userMetadata } = useAuth();
	const token = globalConfig.hardcoded_header;
  const [search, setSearch] = useState("");
  const [state, setState] = useState({
    contentCategories: [],
    filteredContentCategories: [],
  });

  useEffect(() => {
    handleOnLoad();
  }, []);

  useEffect(() => {
    handleSearch(search);
  }, [search]);
  useEffect(() => {
    console.log(state);
  }, [state]);
  const handleOnLoad = () => {
    setLoading(true);
    axios
      .get(`${globalConfig.apiDatahubUrl}/content-categories`,
      apiHeader(token))
      .then((res) => {
        const contentCategories = res.data;
        console.log(contentCategories);
        setState({
          ...state,
          contentCategories: contentCategories,
          filteredContentCategories: contentCategories,
        });
        setLoading(false);

        console.log(res.data[0]);
      })
      .catch((x) => {
      });
  };
  function onDelete(event) {
    let deleteID = event.target.id;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-categories/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        setState({
          ...state,
          contentCategories: [],
          filteredContentCategories: [],
        });
        handleOnLoad();
      })
      .catch((err) => console.log("Err delete:" + err));

    setState({
      ...state,
      contentCategories: [],
      filteredContentCategories: [],
    });
    handleOnLoad();
    // this.props.history.push("/list-content-descriptors");
  }

  const handleSearch = (search) => {
    let URL = `${globalConfig.apiDatahubUrl}/content-categories?filter[limit]=50`;
    URL += `&filter[where][or][0][contentCategoryName][regexp]=/(${search})/i&filter[where][or][1][contentCategoryDescr][regexp]=/(${search})/i`;
    axios.get(URL, apiHeader(token)).then((res) => {
      const contentCategories = res.data;
      console.log(contentCategories);
      setState({ ...state, filteredContentCategories: contentCategories });
      console.log(res.data[0]);
    })
    .catch((x) => {
    });
  };
  const indexOfLastData = currentPage * globalConfig.dataPerPage;
  const indexOfFirstData = indexOfLastData - globalConfig.dataPerPage;
  const currentData = state.filteredContentCategories.slice(
    indexOfFirstData,
    indexOfLastData
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  //handler for page
  const handlePage = (page) => {
    setCurrentPage(page);
  };
  return (
    <form>
    	<div style={{ display: "flex", justifyContent: "space-between" }}>
    		<h4>Content Categories</h4>
		<div style={{display:"flex",justifyContent:"flex-end"}}>
        	<Link to="/breeze/create-content-category">
          <Button
            variant="contained"
            color="success"
          >
            Create
          </Button>
        </Link>&nbsp;
        <Link to="/breeze/list-content-category-types">
          <Button
            variant="contained"
            color="warning"
          >
            Types
          </Button>
        </Link>&nbsp;
		<Link to="/breeze">
			<Button variant="contained">Go Back</Button>
		</Link>
		</div>
		</div>
		<hr/>

        <div className="form-group">
          <input
            className="form-control"
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            id="exampleFormControlInput1"
            placeholder="Search"
          />
        </div>
        
        <div className="form-group row">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Description</th>
                <th scope="col">Type</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {!loading ? (
                currentData.map(
                  ({
                    contentCategoryId,
                    contentCategoryName,
                    contentCategoryDescr,
                    contentCategoryTypeId,
                  }) => {
                    return (
                      <tr>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-categories",
                              search: `?id=${contentCategoryId}`,
                            }}
                          >
                            {contentCategoryId}
                          </Link>
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-categories",
                              search: `?id=${contentCategoryId}`,
                            }}
                          >
                            {contentCategoryName}
                          </Link>{" "}
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-categories",
                              search: `?id=${contentCategoryId}`,
                            }}
                          >
                            {" "}
                            {contentCategoryDescr}
                          </Link>
                        </td>
                        <td>
                          {" "}
                          <Link
                            to={{
                              pathname: "/manage-content-categories",
                              search: `?id=${contentCategoryId}`,
                            }}
                          >
                            {contentCategoryTypeId}
                          </Link>
                        </td>
                        <td>
                          <Link
                            className="btn btn-success"
                            to={{
                              pathname: "/manage-content-categories",
                              search: `?id=${contentCategoryId}`,
                            }}
                          >
                            Edit{" "}
                          </Link>
                          &nbsp;
                          <button
                            onClick={onDelete}
                            id={contentCategoryId}
                            className="btn btn-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    );
                  }
                )
              ) : (
                <tr>
                  {new Array(5).fill(0).map((_, index) => (
                    <TableLoader key={index} theme={"dark"} />
                  ))}
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          dataPerPage={globalConfig.dataPerPage}
          totaldata={state.filteredContentCategories.length}
          paginate={paginate}
          currentPage={currentPage}
          onChange={handlePage}
        />

    </form>
  );
};

export default ListContentCategories;
